import { fetchInitials } from "queries"
import AppsPage from "../../views/apps"
import { GetServerSideProps } from "next"
import useQueryPlus from "utils/useQueryPlus"
import { NextSeo } from "next-seo"
import useT from "utils/useT"

export const getServerSideProps: GetServerSideProps = async ({ query }) => {
  return {
    props: {
      query,
    },
  }
}

const Apps = ({ query }: any) => {
  const t = useT()
  useQueryPlus({
    queryFn: fetchInitials,
    queryKey: ["initialApps"],
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    gcTime: Infinity,
    staleTime: Infinity,
  })
  return (
    <>
      <NextSeo
        title={"Free & Discounted iOS Apps and Games | Appollow"}
        description={t.apps.hero}
        canonical={"https://www.appollow.net/apps"}
        openGraph={{
          url: "https://www.appollow.net/apps",
          title: "Free & Discounted iOS Apps and Games | Appollow",
          description: t.apps.hero,
          siteName: "Appollow",
        }}
      />
      <AppsPage query={query} />
    </>
  )
}
export default Apps
